// if (typeof BSS_B2B) {
//   setTimeout(() =>{
//     const targetProduct = document.querySelector("#shopify-section-ajax-cart");
//     if (targetProduct) {
//       const mutationObserver = new MutationObserver((recordList, observe) => {
//           for (const record of recordList) {
//               if (record.target.classList.contains("shopify-section") && record.addedNodes[0]) {
//                 console.log(345);
//                   BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()),null,false);
//                 BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
//                 }
//           }
//       });
//       mutationObserver.observe(targetProduct, { childList: true, subtree: true });
//     }
//   }, 1000)

//   //fix price display non login
//   if(window.location.pathname.includes('/products')) {
//      let loop = setInterval(() =>{
//       let vatPrice = $(".preisgewichtd .bss-b2b-product-vat-price-no-vat .bss-b2b-translation-td-excluded_vat_text");
//       if(vatPrice.length) {
//           let priceNormal = $(".variant-price").css("display", "none");
//           clearInterval(loop)
//       }
//     }, 1000);

//      setTimeout(() =>{
//        clearInterval(loop)
//     }, 7000)

    
//   }
 
  
// }

if (typeof BSS_B2B) {
    setTimeout(() => {
        const srStatus = BSS_B2B.sr.status;
        const pickup = document.querySelector(".delivery-method .pickup");
        const shipping = document.querySelector(".delivery-method .shipping");
        if (pickup && shipping) {
            if (srStatus) {
                pickup.removeAttribute("checked");
                shipping.setAttribute("checked", true);
            } else {
                shipping.removeAttribute("checked");
                pickup.setAttribute("checked", true);
            }
        }

        const radios = document.querySelectorAll('input[name="deliveryOption"]');
        if (radios.length > 0) {
            radios.forEach(radio => {
                radio.addEventListener("change", function () {
                BSS_B2B.sr.status = this.value === "shipping";
                });
            });
        }
        BSS_B2B?.observer?.cartSubject?.listenCartCheckout();
    }, 5000)
}